import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const ProductAll = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 40 40">
      <rect width="40" height="40" rx="20" fill="#EDF0F2"/>
      <rect x="7.5" y="7" width="10.7143" height="10.7143" rx="1.78571" fill="#2E434D"/>
      <rect x="21.7857" y="7" width="10.7143" height="10.7143" rx="1.78571" fill="#B1B8BC"/>
      <rect x="7.5" y="21.2857" width="10.7143" height="10.7143" rx="1.78571" fill="#B1B8BC"/>
      <rect x="21.7857" y="21.2858" width="10.7143" height="10.7143" rx="1.78571" fill="#2E434D"/>
    </SvgIcon>
  );
}

export default ProductAll;